import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import TableAHSF from "../../../Components/TableAHSF";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import { CompletionArbitrationApplications } from "../../../Redux/Reducers/Manager/SubTask";
import Swal from "sweetalert2";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import { SetArrayDataCheckBoks } from "../../../Redux/Reducers/Shared/CheckBox";

const ApplicationByEvaluator = (porps) => {
  const dispatch = useDispatch();
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);
  const arrayDataCheckBoks = useSelector(
    (state) => state.arrayDataCheckBoks.arrayDataCheckBoks["tasksList"]
  );
  const navigate = useNavigate();
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const UserInfo = useSelector((state) => state.UserInfo.UserInfo);
  const lang = useSelector((state) => state.languageReducer.Language);
  const RequestAccessor = [
    {
      KeyName: "applicationNumber",
      ShowStatus: true,
      NmaeColumn: " رقم الطلب",
      NmaeColumnEN: "Application Number",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },

    {
      KeyName: "applicantfullName",
      ShowStatus: true,
      NmaeColumn: "الاسم الكامل",
      NmaeColumnEN: "Full Name ",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "fieldName",
      ShowStatus: true,
      NmaeColumn: " الحقل ",
      NmaeColumnEN: " Field Name",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "subjectName",
      ShowStatus: true,
      NmaeColumn: "  الموضوع",
      NmaeColumnEN: " Subject Name",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    // {
    //   KeyName: "subTaskMark",
    //   ShowStatus: true,
    //   NmaeColumn: "  مجموع العلامة",
    //   NmaeColumnEN: "Total Mark ",
    //   TotalNumber: true,
    //   DropdownFiltration: {
    //     keyTextName: "",
    //     keyValueName: "",
    //   },
    //   DropdownFiltrationStatus: false,
    //   GroupOfColumns: false,
    // },
    {
      KeyName: "shortList",
      ShowStatus: true,
      NmaeColumn: "  القائمة القصيرة",
      NmaeColumnEN: "Short List ",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "reasonDescription",
      ShowStatus: true,
      NmaeColumn: "  توضيح السبب",
      NmaeColumnEN: " Reason Description",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "subTaskStatus",
      ShowStatus: true,
      NmaeColumn: " حالة التحكيم",
      NmaeColumnEN: " Status",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];

  const RequestsManagerBtns = [
    {
      Click: async (e) => {
        console.log(e.target.value, "ddddddc");
        let value = JSON.parse(e.target.value).subTaskId;

        navigate(
          `/ResearchersAward/manager/evaluation/ApplicationByEvaluator/${value}`
        );
      },
      content: "",
      className: "bi bi-pencil-square",
      id: "editBtn",
      title: "عرض التحكيم",
      ShowStatus: true,
    },
    {
      Click: async (e) => {
        const result = JSON.parse(e.target.value)?.applicationInformationId;

        console.log(result, "sssswdwdwffefssssdwdwdwdwd");
        window.open(
          `/ResearchersAward/manager/ViewApplication/ApplicationInformation/` +
            result,
          "_blank"
        );
      },
      content: "",
      className: "bi bi-view-list",
      id: "editBtn",
      title: "عرض الطلب",
      ShowStatus: true,
    },
  ];

  const RequestsManagerColumns = [];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,

    isPopupOpenFunction: () => {},
    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const popUpBody = {
    isPopupOpenStatus: popUpBodyStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyStatus(false);
    },

    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
  };

  console.log(UserInfo.UserId, "UserInfoUserInfo");

  const EvalApplicationsFinish = async () => {
    const success = await dispatch(
      CompletionArbitrationApplications({ subTaskIdList: [] })
    );
  };

  const validation = async () => {
    const validationMassage = [];

    if (!arrayDataCheckBoks || arrayDataCheckBoks.length === 0)
      validationMassage.push(
        lang == "en"
          ? "Please select at least one request"
          : "الرجاء اختيار طلب واحد على الاقل"
      );

    if (validationMassage.length > 0) {
      Swal.fire({
        icon: "warning",
        title: lang == "en" ? "warning" : "تنبيه",
        html: `
            <div style="text-align: ${
              lang == "en" ? "left" : "right"
            }; direction: ${lang == "en" ? "ltr" : "rtl"}; font-size: 16px;">
              <ul style="list-style-type: none; padding: 0;">
                ${validationMassage
                  .map(
                    (field) =>
                      `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
                  )
                  .join("")}
              </ul>
            </div>
          `,
        confirmButtonText: lang == "en" ? "Ok" : "حسناً",
        customClass: {
          popup: "swal2-border-radius",
        },
      });
      return false;
    } else {
      Swal.fire({
        title: "  هل انت متأكد من اخذ الاجراء ؟",
        icon: "question",
        confirmButtonText: "تأكيد",
        cancelButtonText: "إلغاء",
        showCancelButton: true,
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          const success = await dispatch(
            CompletionArbitrationApplications({
              subTaskIdList: arrayDataCheckBoks.map((item) => item.subTaskId),
            })
          );
          if (!success.payload) {
            Swal.showValidationMessage(
              lang == "en" ? "Something went wrong" : "حدث خطأ، حاول مجدداً"
            );
          }
          return success.payload;
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((res) => {
        if (res.isConfirmed && res.value) {
          Swal.fire({
            icon: "success",
            title:
              lang == "en"
                ? "Order processing completed"
                : "تم الانتهاء من تحويل الطلبات",
            confirmButtonText: lang == "en" ? "Ok" : "حسناً",
            customClass: {
              popup: "swal2-border-radius",
            },
          });
          dispatch(setRefreshTable({ tableId: "TasksByEvalutor" }));
        }
      });
    }

    return true;
  };

  useEffect(() => {
    dispatch(SetArrayDataCheckBoks());
  }, []);
  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        tableId="TasksByEvalutor"
        uniqueValue={""}
        lang={lang}
        valueButtonAction={""}
        URL={`api/Evaluator/GetSubTasksByEvalutorId`}
        UrlBody={{
          userGUID: UserInfo?.UserId,
          lang: lang == "en" ? true : false,
        }}
        dataRedux={arrayDataCheckBoks}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"الطلبات"}
        titelTableEN={"Requests"}
        selectRowNumber={true}
        checkBoksColumName={lang == "en" ? "Select All" : "تحديد الكل"}
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        checkBoksCustomRender={true}
        checkBoksCustomRenderKeyName={"subTaskStatusId"}
        checkBoksCustomRenderKeyValue={["60d6bc25-9608-4585-babf-345116f3c0bb"]}
        checkBoksCustomRenderShowOrHide={false}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={true}
        uniqeKeyNameRedux="tasksList"
        uniqeKeyName="subTaskId"
        nameColumAction=""
        total={false}
        trueText={lang == "en" ? "Yes" : "نعم"}
        falseText={lang == "en" ? "No" : "لا"}
        arrayButton={RequestsManagerBtns}
        ArrayNameDataColum={RequestsManagerColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        // popUpBody={
        //   <PopupAHSF
        //     isPopupOpenStatus={popUpBody.isPopupOpenStatus}
        //     isPopupOpenFunction={popUpBody.isPopupOpenFunction}
        //     title={popUpBody.title}
        //     componentBody={popUpBody.componentBody}
        //     maxWidth={popUpBody.maxWidth}
        //     maxHeight={popUpBody.maxHeight}
        //   />
        // }
      />
      <div className="containerButtonMAin">
        <ButtonAHSF
          type={"submitter"}
          fieldsName="CompletionOfApplicationReview"
          lang={lang}
          text=""
          onClick={() => {
            validation();
          }}
          disabled={false}
          title={""}
          show={true}
        />
      </div>
    </>
  );
};

export default ApplicationByEvaluator;
